import { render, staticRenderFns } from "./AddClassTimeDialog.vue?vue&type=template&id=6c4e362b&scoped=true&"
import script from "./AddClassTimeDialog.vue?vue&type=script&lang=js&"
export * from "./AddClassTimeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddClassTimeDialog.vue?vue&type=style&index=0&id=6c4e362b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e362b",
  null
  
)

export default component.exports